import React from 'react';
import {ICheckboxListProps} from "../../../interfaces/lists/ICheckboxList";

const CheckboxList = ({title, items, className = '',}: ICheckboxListProps) => {

    return (
        <div className={`checkbox-list-wrapper ${className}`}>
            {title && <p className="checkbox-list-title">{title}</p>}
        
            <ul className="checkbox-list">
                {items.map((item) => {
                    const key = `${item.text}-${item.value}`.split(' ').join('-');
                    const checkboxId = `checkbox-item-${key}`;
            
                    return (
                        <li key={`checkbox-list-item-${key}`} className={`checkbox-list-item ${item.disabled ? 'disabled-style' : ''}`} >
                            <input
                                type="checkbox"
                                id={checkboxId}
                                className="checkbox-input"
                                checked={item.checked}
                                disabled={item.disabled}
                                onChange={(e) => {
                                    e.preventDefault();
                                    item.onChange();
                                  }}
                                aria-checked={item.checked} 
                                aria-disabled={item.disabled} 
                            />

                            <label 
                                className="checkbox-label-text" 
                                htmlFor={checkboxId} 
                                onClick={(e) => {
                                    e.preventDefault();
                                    item.onChange();
                                }}>
                                {item.text}
                            </label>
                        </li>
                    );
                })}
            </ul>
        </div>
      );
};

export default CheckboxList;
